export const sortSubmissions = (submissions: Submission[]) => {
	return submissions.sort((a, b) => {
		return b.createdAt - a.createdAt;
	});
};

export const submissionApprovalThreshold = 3;
